import { DeliveryInformation, LocationSilo, Silo } from '@next/core-lib/cart';
import { createAction, props } from '@ngrx/store';

import { RepeatOrderAggregationRequest, RepeatOrderType } from '../components/repeat-order/pages/abstract-repeat-order-page-component.directive';
import { SiloProductItem } from '../components/silos/models/silo-product-list.models';

import { CatalogItem } from '../models/catalog-item.model';
import { Order, OrderDetails } from '../models/order.models';
import { ProductQuery } from '../models/product-query.model';
import { RepeatOrderItem } from '../models/repeat-order-item.model';
import { SearchCatalogItem } from '../models/search.models';
import { SortMode } from '../models/sort-mode.model';

export const setBannerNotificationVisibility = createAction('[App] Set banner notification visibility', props<{ visible: boolean }>());

export const ordersRequest = createAction('[App] Orders request', props<{ itemsToDisplay?: number }>());

export const ordersSuccess = createAction('[App] Orders success', props<{ orders: Order[] }>());

export const clearOrdersRequest = createAction('[App] Clear orders request');

export const ordersFailure = createAction('[App] Orders failure');

export const orderDetailsRequest = createAction('[App] Order details request', props<{ id: number }>());

export const orderDetailsSuccess = createAction('[App] Order details success', props<{ orderDetails: OrderDetails }>());

export const orderDetailsFailure = createAction('[App] Order details failure');

export const clearOrderDetailsRequest = createAction('[App] Clear order details request');

export const catalogCategoriesRequest = createAction('[App] Catalog categories request', props<{ isRoot: boolean }>());

export const catalogCategoriesSuccess = createAction('[App] Catalog categories success', props<{ catalogCategories: CatalogItem[] }>());

export const catalogCategoriesFailure = createAction('[App] Catalog categories failure');

export const catalogProductsRequest = createAction('[App] Catalog products request', props<{ productQuery: ProductQuery }>());

export const catalogProductsSuccess = createAction('[App] Catalog products success', props<{ catalogProducts: CatalogItem[] }>());

export const catalogProductsFailure = createAction('[App] Catalog products failure');

export const setSelectedCatalogCategory = createAction('[App] Set selected catalog category', props<{ selectedCatalogCategory: CatalogItem }>());

export const setCatalogProductSearchString = createAction('[App] Set catalog product search string', props<{ catalogProductSearchString: string }>());

export const setCatalogSortMode = createAction('[App] Set catalog sort mode', props<{ catalogSortMode: SortMode }>());

export const setCatalogTotalNumberOfProductsFound = createAction(
  '[App] Set catalog total number of products found',
  props<{ catalogTotalNumberOfProductsFound?: number }>(),
);

export const catalogSubcategoriesSuccess = createAction('[App] Catalog subcategories success', props<{ catalogSubcategories: CatalogItem[] }>());

export const catalogItemRequest = createAction('[App] Catalog, get item by Id request', props<{ id: string }>());

export const catalogItemRequestSuccess = createAction('[App] Catalog, get item by Id request success', props<{ catalogItem: CatalogItem }>());

export const catalogItemRequestFailure = createAction('[App] Catalog, get item by Id request failure');

export const catalogSubcategoriesFailure = createAction('[App] Catalog subcategories failure');

export const openAddToCart = createAction('[App] Open add to cart', props<{ catalogItem: SearchCatalogItem }>());

export const deleteSiloRequest = createAction('[App] Delete silo request', props<{ silo: LocationSilo }>());

export const deleteSiloProductListItemRequest = createAction(
  '[App] Delete silo product list item request',
  props<{ siloId: number; siloProductItem: SiloProductItem }>(),
);

export const addSiloRequest = createAction('[App] Add silo request', props<{ silo: LocationSilo }>());

export const updateSiloRequest = createAction('[App] Upsert silo request', props<{ silo: LocationSilo }>());

export const openEditSiloDialogSuccess = createAction('[App] Open edit silo dialog success');

export const openEditSiloDialog = createAction('[App] Edit silo request', props<{ silo?: LocationSilo }>());

export const editSiloSuccess = createAction('[App] Edit silo success');

export const openSiloProductSupplementsDialog = createAction(
  '[App] Open siloProductSupplements dialog',
  props<{ siloId: number; siloProduct: SiloProductItem }>(),
);

export const openSiloProductSupplementsDialogSuccess = createAction('[App]  Open siloProductSupplements dialog success');

export const openOrderDetails = createAction('[App] Open order details');

export const repeatOrdersRequest = createAction('[App] Repeat orders request', props<{ aggregationType: RepeatOrderAggregationRequest }>());

export const repeatOrdersRequestSuccess = createAction(
  '[App] Repeat orders request success',
  props<{ bulk: RepeatOrderItem[]; generalCargo: RepeatOrderItem[]; aggregationType: RepeatOrderAggregationRequest }>(),
);

export const openRepeatOrderSiloDistributionDialog = createAction(
  '[App] Repeat order silo distribution dialog',
  props<{ repeatOrderItem: RepeatOrderItem; quantity: number }>(),
);

export const openRepeatOrderSiloDistributionDialogSuccess = createAction('[App] Repeat order silo distribution dialog success');

export const updateSiloDistribution = createAction('[App] Repeat order update silo distribution', props<{ silos: Silo[]; internalId: number }>());

export const openRepeatOrderDeliveryDateDialog = createAction(
  '[App] Repeat order delivery date dialog',
  props<{ repeatOrderItem: RepeatOrderItem; repeatOrderType: RepeatOrderType; deliveryInformation?: DeliveryInformation }>(),
);

export const openRepeatOrderDeliveryDateDialogSuccess = createAction('[App] Repeat order delivery date dialog success');

export const updateBulkDeliveryInformation = createAction(
  '[App] Repeat order Bulk update DeliveryInformation',
  props<{ deliveryInformation: DeliveryInformation; internalId: number }>(),
);

export const updateCargoDeliveryInformation = createAction(
  '[App] Repeat order Cargo update DeliveryInformation',
  props<{ deliveryInformation: DeliveryInformation; internalId: number }>(),
);
